/* eslint-disable max-depth */
import { put, takeEvery, all, call, select } from 'redux-saga/effects';
import actionTypes from '../../../redux/actions/action-types';
import { merge } from 'highed';
import { uuid } from '../../../editor/core/highcharts-editor';
import { cloneDeep, isArray } from 'lodash';
import { getThemeDetails } from './ChartEditorThemesHelper';
import { updateAggregated, initChart } from './ChartEditor';
import { getProjectConfig } from '../../../redux/selectors/projectConfig';
import { setAction as setProjectConfigAction } from '../../../redux/actions/projectConfig';
import { getChartConfig } from '../selectors/chartEditor';
import { loadCSS } from '../../LayoutEditorPage/components/StoryHelpers';

export function* assignTheme(params) {
  let { theme, team } = params.data;
  const config = yield select(getProjectConfig);
  let chartConfig = yield select(getChartConfig);
  const { isMap } = chartConfig;
  let { customizedOptions } = config;
  let plugins = cloneDeep(config.plugins);

  let themeDetails = yield call(getThemeDetails, team?.id, theme.id);

  let themeMeta = {};

  if (Object.keys(themeDetails).length === 0) {
    return false;
  }

  let themeOptions = {};
  if (themeDetails && themeDetails.options && (themeDetails.id || themeDetails.isevervizTheme)) {
    // Assume that this uses the new format
    themeMeta = {
      id: themeDetails.id || uuid(),
      name: themeDetails.name || themeDetails.id,
      plugins: themeDetails.plugins,
      isevervizTheme: themeDetails.isevervizTheme
    };

    if (isMap) {
      if (themeDetails.options.series && isArray(themeDetails.options.series)) {
        themeDetails.options.series.forEach(function (serie) {
          serie.data = [];
        });
      }
      if (themeDetails.options.chart && themeDetails.options.chart.map) {
        delete themeDetails.options.chart.map;
      }
    }

    themeOptions = merge({}, themeDetails.options);

    if (isMap) {
      if (!themeOptions.chart || (themeOptions.chart && !themeOptions.chart.type)) {
        if (themeOptions.series && isArray(themeOptions.series) && themeOptions.series.length > 0) {
          const allEqual = (arr) => arr.every((v) => v.type === arr[0].type);
          const series = themeOptions.series;
          if (allEqual(series)) {
            if (!themeOptions.chart) themeOptions.chart = {};
            themeOptions.chart.type = series[0].type;
          }
        }
      }
    }

    /*
    if (themeDetails.stockConstr) {
      if (isArray(M.constr)) {
        M.constr[0] = 'StockChart'
      }
    }*/

    //  this.themeCustomCode = themeDetails.customCode || '';
  } else {
    themeMeta = {
      id: uuid(),
      name: 'Untitled Theme'
    };

    if (isMap) {
      if (themeDetails.series && isArray(themeDetails.series)) {
        themeDetails.series.forEach(function (serie) {
          serie.data = [];
        });
      }
    }

    themeOptions = merge({}, themeDetails);
  }

  let cssModules = plugins.cssModules || [];
  if (themeDetails?.plugins?.cssModules) {
    themeDetails.plugins.cssModules.forEach((module) => {
      loadCSS(module, true);

      if (!cssModules.includes(module)) {
        cssModules.push(module);
      }
    });
  }

  if (cssModules.length) {
    plugins.cssModules = cssModules;
  }

  let newCustomizedOptions = {
    series: cloneDeep(customizedOptions.series || []),
    data: cloneDeep(customizedOptions.data || {})
  };

  (newCustomizedOptions?.series ?? []).forEach((series) => {
    if (series.yAxis) delete series.yAxis;
  });

  if (customizedOptions?.chart?.map) {
    if (!newCustomizedOptions.chart) newCustomizedOptions.chart = {};
    newCustomizedOptions.chart.map = customizedOptions.chart.map;
  }

  if (themeOptions?.lang) {
    Highcharts.setOptions({
      lang: themeOptions.lang
    });
  }

  yield put(
    setProjectConfigAction({
      customizedOptions: newCustomizedOptions,
      themeOptions,
      themeMeta,
      plugins,
      changeMade: true
    })
  );

  yield call(updateAggregated);
  yield call(initChart);
}

/** Watch functions */
export function* watchAssignTheme() {
  yield takeEvery(actionTypes.chartEditor.assignTheme, assignTheme);
}

export default function* rootSaga() {
  yield all([watchAssignTheme()]);
}
